export default __webpack_public_path__ + "static/media/downArrowYellow.4b14f8d8.svg";